import { autoserialize, autoserializeAs } from 'cerialize';

export class TaxReceiptSettings {
  @autoserializeAs('primary_color') primaryColor?: string;
  @autoserialize ein?: string;
  @autoserialize logo?: string;
  @autoserialize disclaimer?: string;
  @autoserialize accepted_items_only?: boolean;
  @autoserializeAs('show_signature') showSignature?: boolean;
  @autoserializeAs('show_dock_signature') showDockSignature?: boolean;
  @autoserializeAs('mission_statement') missionStatement?: string;
  @autoserializeAs('manager_signature') managerSignature?: string;
  @autoserializeAs('manager_name') managerName?: string;
  @autoserializeAs('manager_official_title') managerOfficialTitle?: string;

  constructor(pricingPayload?: ITaxReceiptSettings | null) {
    this.primaryColor = pricingPayload?.primaryColor;
    this.ein = pricingPayload?.ein;
    this.logo = pricingPayload?.logo;
    this.disclaimer = pricingPayload?.disclaimer;
    this.accepted_items_only = pricingPayload?.accepted_items_only;
    this.showSignature = pricingPayload?.showSignature;
    this.showDockSignature = pricingPayload?.showDockSignature;
    this.missionStatement = pricingPayload?.missionStatement;
    this.managerSignature = pricingPayload?.managerSignature;
    this.managerName = pricingPayload?.managerName;
    this.managerOfficialTitle = pricingPayload?.managerOfficialTitle;
  }
}

export interface ITaxReceiptSettings {
  primaryColor?: string;
  ein?: string;
  logo?: string;
  disclaimer?: string;
  accepted_items_only?: boolean;
  showSignature?: boolean;
  showDockSignature?: boolean;
  missionStatement?: string;
  managerSignature?: string;
  managerName?: string;
  managerOfficialTitle?: string;
}
